import akunApi from '../../services/akunApi'

const SET_AUTH_SERVICE = "SET_AUTH_SERVICE"

const state = {
	data: null
}

const mutations = {
	[SET_AUTH_SERVICE](state, data) {
		state.authService = data
	}
}

const actions = {
	async getAllAkun({ getters }, data) {
		let token = getters.getAuthService.token
		return await akunApi.getAllAkun(data, token)
	},
	async getAkunByDesa({ getters }, data) {
		let token = getters.getAuthService.token
		return await akunApi.getAkunByDesa(data, token)
	},
	async getAkunByKecamatan({ getters }, data) {
		let token = getters.getAuthService.token
		return await akunApi.getAkunByKecamatan(data, token)
	},
	async updateAkun({ getters }, data) {
		let token = getters.getAuthService.token
		return await akunApi.updateAkun(data.id, data.data, token)
	},
	async resetPassword({ getters }, id) {
		let token = getters.getAuthService.token
		return await akunApi.resetPassword(id, token)
	},
	async disableAkun({ getters }, id) {
		let token = getters.getAuthService.token
		return await akunApi.disableAkun(id, token)
	},
	async enableAkun({ getters }, id) {
		let token = getters.getAuthService.token
		return await akunApi.enableAkun(id, token)
	},
	async hapusAkun({ getters }, id) {
		let token = getters.getAuthService.token
		return await akunApi.hapusAkun(id, token)
	},
	async generateOtp({ getters }, id) {
		let token = getters.getAuthService.token
		return await akunApi.generateOtp(id, token)
	},
}

const getters = {

}

export default {
	state,
	mutations,
	actions,
	getters
}